(function (angular) {
    'use strict';

    angular.module('settings')
        /**
         *
         */
        .controller('usersCtrl', ['$scope', 'jwtService', 'usersData', 'usersService', 'growlService', 'permissionService', '$uibModal', 'roles', 'sweetAlertService', function ($scope, jwtService, usersData, usersService, growlService, permissionService, $uibModal, roles, sweetAlertService) {
            $scope.writePermission = permissionService.checkPermission("mem:usr:wa");
            $scope.deletePermission = permissionService.checkPermission("mem:usr:da");
            $scope.accountId = jwtService.payload.accountId;
            $scope.userId = jwtService.payload.userId;

            $scope.roleName = roles.reduce((obj, item) => {
                obj[item.value] = item.name
                return obj
              }, {});
            
            $scope.checkData = function(usersData){
                if (usersData && (!usersData.status || usersData.status != 404)) {
                    for (var i in usersData) {
                        var temporaryRoles = [];
                        for (var j in usersData[i].roles) {
                            var check = false;
                            for (var k in roles) {
                                if (usersData[i].roles[j] == roles[k].value) {
                                    check = true;
                                }
                            }
                            if (check) {
                                temporaryRoles.push(usersData[i].roles[j]);
                            }
                        }
                        usersData[i].roles = temporaryRoles;
                    }
                    $scope.usersData = usersData;
                }
                else {
                    $scope.usersData = [];
                }
            }
            
            $scope.checkData(usersData);

            $scope.open = function (user) {
                var modalInstance = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'components/settings/templates/add-user-modal.html',
                    controller: 'addUserModal',
                    size: 'md',
                    resolve: {
                        user: function () {
                            return user;
                        },
                        accountId: function () {
                            return $scope.accountId;
                        },
                        roles: function () {
                            return roles;
                        },

                    }
                });

                modalInstance.result.then(function () {
                    
                    usersService.refreshUsers($scope.accountId).then(function (result){
                        
                        $scope.checkData(result);
                        
                    });
                    $scope.apply();
                    
                }, function () {
                    // $log.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.delete = function (user) {
                sweetAlertService.confirmationAlert(
                    "Are you sure?",
                    "you will not be able to recover this user!",
                    "Remove",
                    "No",
                    function (isConfirmed) {
                        if (isConfirmed) {
                            usersService.deleteUser($scope.accountId, user.userId).then(function (result) {
                                growlService.success('User deleted');
                            }).catch(function (error) {
                                growlService.danger("User wasn't deleted due to: " + error.statusText);
                            });
                        }
                    }
                );

            };
        }]).controller('addUserModal', ["$scope", '$q', "$uibModalInstance", "usersService", "user", "roles", "accountId", 'growlService', 'utilService', 'totpService', 'totpStatus',
            function ($scope, $q, $uibModalInstance, usersService, user, roles, accountId, growlService, utilService, totpService, totpStatus) {
                $scope.newUser = user === null;
                $scope.userRole = [];
                $scope.user = {};
                $scope.data = {
                    isTotpReset: false
                };
                if (user) {
                    $scope.user = angular.copy(user);
                    for (var i in $scope.user.roles) {
                        for (var j in roles) {
                            if ($scope.user.roles[i] == roles[j].value) {
                                $scope.userRole.push(roles[j]);
                            }
                        }
                    }

                    $scope.idsBag = {
                        userId: $scope.user.userId,
                        accountId: $scope.user.accountId
                    }

                    $q.all([
                        totpService.isTotpActivated($scope.idsBag),
                        totpService.getTotpStatus($scope.idsBag)
                    ]).then(function(responses) {
                        const currentTotpStatus = totpStatus[responses[1].totpStatus];
                        $scope.user.isTotpEnabled = responses[0].result && currentTotpStatus === totpStatus.Enabled;
                    });
                }
                $scope.roles = roles;
                $scope.ok = function () {
                    $scope.user.deletedRoles = [];
                    $scope.user.roles = [];
                    for (var i in $scope.userRole) {
                        $scope.user.roles.push($scope.userRole[i].value);
                    }
                    if ($scope.newUser) {
                        usersService.createUser(accountId, $scope.user).then(function (result) {
                            $uibModalInstance.close(result);
                            growlService.success('New user added');
                        }).catch(function (error) {
                            if (error.status == 409) {
                                growlService.danger("User with this email address already exist", 0);
                            }
                            else {
                                growlService.danger("User wasn't created due to: " + error.statusText);
                            }
                        });
                    }
                    else {
                        for (var j in user.roles) {
                            if ($scope.user.roles.indexOf(user.roles[j]) == -1) {
                                $scope.user.deletedRoles.push(user.roles[j]);
                            }
                        }
                        usersService.updateUser(accountId, $scope.user).then(function (result) {
                            $uibModalInstance.close(result);
                            growlService.success('User updated');
                        }).catch(function (error) {
                            growlService.danger("User wasn't updated due to: " + error.statusText);
                        });
                        
                        if ($scope.data.isTotpReset) {
                            totpService.updateTotpStatus($scope.idsBag, totpStatus.Enrolling);
                        }
                    }
                };

                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                $scope.validatePassword = function () {
                    if ($scope.user.password) {
                        if ($scope.user.password.length >= 8) {
                            if ($scope.user.password.toLowerCase() != $scope.user.password && $scope.user.password.toUpperCase() != $scope.user.password) {
                                if ($scope.user.password.match(/\d+/g) !== null) {
                                    if (/^[a-zA-Z0-9- ]*$/.test($scope.user.password)) {
                                        $scope.passwordValidationMessage = "Password should contain at least one special char";
                                    }
                                    else {
                                        return false;
                                    }
                                }
                                else {
                                    $scope.passwordValidationMessage = "Password should contain at least one number";
                                }
                            }
                            else {
                                $scope.passwordValidationMessage = "Password should contain at least one capital and one lower case letter";
                            }
                        }
                        else {
                            $scope.passwordValidationMessage = "Password should be at least 8 characters long";
                        }
                        return true;
                    }
                    return false;
                };

                $scope.validateConfirmPassword = function(){
                    if($scope.newUser){
                        if($scope.user.password && $scope.user.confirmPassword){
                            if($scope.user.password === $scope.user.confirmPassword){
                                return true;
                            }
                            else {
                                $scope.confirmPasswordValidationMessage = "Passwords aren't the same";
                            }
                            return false;
                        }
                        return false;
                    }  
                    return true;
                }

                $scope.validateEmail = function () {
                    if (utilService.validateEmail($scope.user.email)) {
                        return true;
                    }
                    else {
                        $scope.emailValidationMessage = "This doesn't look like a valid email address";
                        return false;
                    }
                };

            }]);
})(window.angular);